module.exports = __webpack_public_path__ + "static/media/u-story-group-icon-v2.30bd3cda.png";